import React from "react";
import SettingsSection from "../../Sections/Settings";
import Dashboard from "../Dashboard/Dashboard";

const SettingsComponent = () => {
    return (
        <Dashboard sectionName={<SettingsSection />}/>
    );
};

export default SettingsComponent;
